<template>
  <div>
    <el-table :data="data.data" :highlight-current-row="true" stripe>
      <el-table-column label="Name">
        <template slot-scope="props">
          {{ props.row.user.first_name }} {{ props.row.user.surname }}
        </template>
      </el-table-column>
      <el-table-column label="Channel">
        <template slot-scope="props">
          <span v-for="(c, i) in props.row.user.channels" :key="i">
            <a
              v-if="c.platform === 'youtube'"
              :href="`https://youtube.com/channel/${c.channel_id}`"
              target="_blank"
            >
              {{ c.channel_name }}
            </a>
            <!-- <span style="color:red" v-else>No channel</span> -->
          </span>
        </template>
      </el-table-column>
      <el-table-column label="E-mail" prop="user.email"></el-table-column>
      <el-table-column label="PayPal" prop="user.paypal">
        <template slot-scope="props">
          <el-tag
            v-if="props.row.user.paypal"
            :type="props.row.user.paypal_verify ? 'success' : 'danger'"
          >
            {{ props.row.user.paypal }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Amount" prop="amount">
        <template slot-scope="props">
          ${{ commaNum(props.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="Current balance" prop="user.wallet.balance">
        <template slot-scope="props">
          <span v-if="props.row.user.wallet">
            ${{ commaNum((props.row.user.wallet.balance / 10).toFixed(2)) }}<br />
            {{ commaNum(props.row.user.wallet.balance.toFixed(2)) }} VC
          </span>
          <span v-else>No balance yet</span>
        </template>
      </el-table-column>
      <el-table-column label="Status">
        <template slot-scope="props">
          <el-tag v-if="!props.row.pay_date">
            Active
          </el-tag>
          <el-tag v-else type="success">
            Paid {{ props.row.pay_date | date }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Request date">
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip v-if="!props.row.pay_date" content="Paid">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-check"
              @click="paid(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="data.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="data.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('vcPayPal', [
      'data',
      'loading',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapMutations('vcPayPal', ['setPage', 'setPageSize', 'setOrdering']),
    ...mapActions('vcPayPal', ['read', 'paid']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
